export default "__VITE_ASSET__32d29b78__"